import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button } from '@mui/material';
import { getMyPendingUserInvites } from '../../../api/userInviteService';
import { useDeleteUserInviteByHash } from '../../../hooks/users/useDeleteUserInviteByHash';
import ConfirmDialog from '../../common/modals/ConfirmDialog';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useAcceptUserInvite } from '../../../hooks/users/useAcceptUserInvite';
import InviteAcceptedModal from './InviteAcceptedModal';

export default function InviteNotification({content}) {
  const { t } = useTranslation('common'); 
  const [open, setOpen] = useState(true);
  const [data, setData] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [inviteAcceptedModalOpen, setInviteAcceptedModalOpen] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  const onDeclineSuccess = () => {
    setConfirmDialogOpen(false);
    showSnackbar(t('user_invites.messages.decline_success'), "success");
  };

  const { remove } = useDeleteUserInviteByHash(onDeclineSuccess);

  const handleDecline = async () => {
    await remove(data.hash);
  };

  const onAcceptSuccess = async () => {
    showSnackbar(t('user_invites.messages.accept_success'), "success");
    setInviteAcceptedModalOpen(true);
  };

  const { accept } = useAcceptUserInvite(onAcceptSuccess);

  const handleAccept = async () => {
    setOpen(false);
    await accept({hash: data.hash}); 
  };

  const fetchData = async () => {
    try {
      const data = await getMyPendingUserInvites();
      setData(data);
    } catch(error) {
      // setMessage("Invalid invite request");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!data?.id) {
    return (
      null
    );
  }

  return (
    <>
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity="info" 
        icon={false}
        sx={{ 
          width: '100%',
          boxShadow: 4, // MUI theme shadow level
          borderRadius: 1, // optional: rounded corners
        }}
        action={
          <>
            <Button color="inherit" size="small" onClick={handleAccept}>
              Accept
            </Button>
            <Button 
              color="inherit" 
              size="small" 
              onClick={() => {
                setOpen(false);
                setConfirmDialogOpen(true);
              }}
            >
              Decline
            </Button>
          </>
        }
      >
        {data.inviter.name} has invited you to join {data.office.name} as {data.type} user.
      </Alert>
    </Snackbar>
    <ConfirmDialog
      open={confirmDialogOpen}
      title="Decline Invitation"
      content="Are you sure you want to decline this invitation?"
      confirmText="Decline Invitation"
      cancelText="Cancel"
      onConfirm={handleDecline}
      onCancel={() => {
        setConfirmDialogOpen(false);
        setOpen(true);
      }}
    />
    {data?
      <InviteAcceptedModal 
        userInvite={data}
        open={inviteAcceptedModalOpen}
        onClose={() => setInviteAcceptedModalOpen(false)}
      />
    : null }
    </>
  );
}
